module.exports = __webpack_public_path__ + "static/assets/45345b5f49c8419e6409990f7b1874b0.jpg";